<template>
  <section id="categories">
    <h2 class="sr-only">Icon Categories</h2>

    <div class="categories-listing-featured margin-bottom-2xl">
      <h3 class="sr-only">Featured Categories</h3>
      <category-card
        v-for="(category, index) in featuredCategories"
        :key="`featured-${category.id}`"
        :category="category"
        :is-last="featuredCategories.length === index + 1"
      >
        <div
          slot="visuals"
          class="visuals padding-bottom-md"
        >
          <i
            v-for="icon in category.visuals"
            :key="icon"
            :class="`fas fa-${icon} fa-fw size-2xl`"
          />
        </div>
      </category-card>
    </div>

    <div class="categories-listing">
      <h3 class="sr-only">All Categories</h3>
      <category-card
        v-for="(category, index) in categories"
        :key="category.id"
        :category="category"
        :is-last="categories.length === index + 1"
      />
    </div>
  </section>
</template>

<script>
  // TODO V7: update this and computed below for V7 categories
  const categoriesV6 = require('app/views/icons/category-figures/v6.json')
  const categoriesV5 = require('app/views/icons/category-figures/v5.json')

  import IconsLandingData from '../IconsLandingData.json'
  import CategoryCard from './CategoryCard'

  export default {
    name: 'IconsCategories',

    components: {
      CategoryCard
    },

    props: {
      release: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        rawFeaturedCategories: IconsLandingData.featuredCategories
      }
    },

    computed: {
      categories() {
        return this.release.versionParts.major === 6 ? categoriesV6 : categoriesV5
      },

      featuredCategories() {
        const versionSpecificCategories = this.rawFeaturedCategories[`v${this.release.versionParts.major}`] || {}

        return this.categories
          .map((category) => {
            const visuals = versionSpecificCategories[category.id]?.visuals
            return visuals ? { ...category, visuals } : null
          })
          .filter(Boolean) // filter out null values
      }
    },

    mounted() {
      this.$posthog.capture('icons_landing:categories_tab_view')
    }
  }
</script>
